import * as Sentry from "@sentry/react";
import { Suspense, useContext, useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { LoadingView } from "../components";
import { LoginContextProvider } from "../context";
// import RouterContext from "./RouterContext";
import { SupportedDeviceContextProvider } from "../context/SupportedDeviceContext";
import { useGetSeoList } from "../hooks/HomeProduct/homeproduct.hooks";
import RouterContext from "./RouterContext";
import layouts from "./layouts";
import RouterList from "./router";

const findRouteConfig = (currentPath = "") => {
  let target: any = RouterList.find((route) => {
    return (
      route.path === currentPath || window.location.pathname === currentPath
    );
  });
  if (!target) return "default";

  return !!target ? target : {}; //background
};

function withRouter(Component: any) {
  function ComponentWithRouterProp(props: any) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

const RouterRender = ({
  router,
  match,
  showTransform,
}: {
  router: any;
  match: any;
  showTransform: any;
}) => {
  const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

  let { location } = router;
  // const { changeLayout, changeNavType } = useContext(RouterContext);
  const { changeNavType } = useContext(RouterContext);

  useEffect(() => {
    // console.log(location);
    // changeLayout(findRouteConfig(location.pathname)?.layout);
    changeNavType(findRouteConfig(location.pathname)?.navType);
  }, [location]);

  return (
    <TransitionGroup>
      <CSSTransition
        classNames={"fade"}
        in={match != null}
        timeout={0}
        key={location?.key}
        appear
      >
        <Suspense fallback={<LoadingView />}>
          <SentryRoutes>
            {RouterList.map((route: any, index) => {
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={<route.component {...route.props} />}
                />
              );
            })}
          </SentryRoutes>
        </Suspense>
      </CSSTransition>
    </TransitionGroup>
  );
};

const RouterRenderWithRouter = withRouter(RouterRender);

// SEO 处理组件，需要在 Router 内部使用 useLocation
const SeoHandler = () => {
  const location = useLocation();
  const path = location.pathname;
  const [searchParams] = useSearchParams();
  const needSeoPath = [
    "/",
    "/product",
    "/installguide",
    "/commonissue",
    // "/cart",
    // "/singin",
    // "/signup",
  ];

  const { data: seoData } = useGetSeoList(
    {
      code: path === "/product" ? searchParams.get("code") : "",
      page: needSeoPath.includes(path)
        ? path === "/"
          ? "main"
          : path.split("/")[1]
        : "main",
    },
    {}
  );

  // ---SEO---
  useEffect(() => {
    if (seoData) {
      document.title = seoData?.title; // Change the title
      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute("content", seoData?.description); // Change the description
      }
    }
  }, [seoData]);

  useEffect(() => {
    console.debug("path", path);
  }, [path]);

  return null;
};

const ProcessRouter = () => {
  // const [layout, setLayout] = useState(findRouteConfig()?.layout ?? "default");
  const [navType, setNavType] = useState({});
  const actions = {
    // changeLayout: (layout = "default") => {
    //   setLayout(layout ?? "default");
    // },
    changeNavType: (navType = {}) => {
      setNavType(navType ?? {});
    },
  };

  var LayoutComponet = layouts["default"];

  return (
    <RouterContext.Provider value={actions}>
      <Router>
        <LoginContextProvider>
          <SupportedDeviceContextProvider>
            <SeoHandler />
            <LayoutComponet navType={navType ? navType : { type: "default" }}>
              <RouterRenderWithRouter />
            </LayoutComponet>
          </SupportedDeviceContextProvider>
        </LoginContextProvider>
      </Router>
    </RouterContext.Provider>
  );
};

export default ProcessRouter;
